import React from 'react';
//import styled from 'styled-components';

export default function Layout({ children }) {
  return (
    <>
      {/* <ContainerStyles className="container">{children}</ContainerStyles> */}
      {children}
    </>
  );
}
